import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { AppStateFacade, Setting, } from '@app-state';
import { CSVCalendarFields, } from '@models';
import { MapperService } from '@services';
import { CSVParser, ICSVParseErrorCode, ICSVParseErrorType, } from '@services/csv-parser.service';
import { SUPPORTED_DATE_FORMATS } from '@services/generics/constants';
import { ODataService } from '@services/generics/odata.service';
import * as moment from 'moment';
import { of, throwError, } from 'rxjs';
import { map, switchMap, } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./csv-parser.service";
import * as i3 from "../app-state/app-state.facade";
var CalendarService = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarService, _super);
    function CalendarService(http, _parser, _appState) {
        var _this = _super.call(this, http, MapperService.excludedCalendarMapper) || this;
        _this._parser = _parser;
        _this._appState = _appState;
        _this._endpoint = '/odata/Calendars';
        return _this;
    }
    CalendarService.prototype.getDefaultCalendar = function () {
        var _this = this;
        var endpoint = this._endpoint + "/UiPath.Server.Configuration.OData.GetDefaultCalendar()";
        return this._http.get(endpoint)
            .pipe(map(function (response) { return _this._mapData(response, MapperService.excludedCalendarMapper); }));
    };
    CalendarService.prototype.updateAndMap = function (id, data) {
        var _this = this;
        return this.update(id, data)
            .pipe(map(function (response) { return _this._mapData(response, MapperService.excludedCalendarMapper); }));
    };
    CalendarService.prototype.isCalendarNameValid = function (calendarName) {
        if (!calendarName) {
            return throwError(null);
        }
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.CalendarExists", { calendarName: calendarName })
            .pipe(switchMap(function (response) {
            return response.value ? throwError(null) : of(true);
        }));
    };
    CalendarService.prototype.parseFile = function (file) {
        var _this = this;
        return this._parser.parseFile(file, {
            header: true,
            skipEmptyLines: true,
            dynamicTyping: true,
            maxFileSize: 128 * 1024,
        }).pipe(map(function (_a) {
            var data = _a.data, errors = _a.errors, meta = _a.meta;
            return ({
                meta: meta,
                // this._rowMapper mutates the errors argument.
                data: data.map(function (row, i) { return _this._rowMapper(row, i, errors); }),
                // sort and switch to 1-indexed rows.
                errors: errors.map(function (err) { return (tslib_1.__assign({}, err, { row: err.row + 1 })); }).sort(function (err1, err2) { return err1.row - err2.row; }),
            });
        }));
    };
    CalendarService.prototype._parseDate = function (row, errors, field, dateString) {
        if (!dateString) {
            errors.push({
                type: ICSVParseErrorType.FieldMismatch,
                code: ICSVParseErrorCode.InvalidData,
                row: row,
                field: field,
            });
            return;
        }
        var parsedDate = moment.tz(dateString, SUPPORTED_DATE_FORMATS, true, this._appState.settings.get(Setting.timezone));
        if (parsedDate.isValid()) {
            return parsedDate;
        }
        errors.push({
            type: ICSVParseErrorType.FieldError,
            code: ICSVParseErrorCode.InvalidData,
            row: row,
            field: field,
        });
    };
    CalendarService.prototype._rowMapper = function (row, index, errors) {
        return {
            excludedDate: this._parseDate(index, errors, CSVCalendarFields.ExcludedDate, row.ExcludedDate),
        };
    };
    CalendarService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CalendarService_Factory() { return new CalendarService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.CSVParser), i0.ɵɵinject(i3.AppStateFacade)); }, token: CalendarService, providedIn: "root" });
    return CalendarService;
}(ODataService));
export { CalendarService };
